/* eslint-disable react/require-default-props */
/* eslint-disable react/button-has-type */
/* eslint-disable @typescript-eslint/no-use-before-define */
import TrainingExperienceForm from '@/components/dashboard/members/profile/trainingExperiences/TrainingExperienceForm'
import {
  RemoveTrainingExperienceDocument,
  TrainingExperience,
} from '@/types/graphql/types'
import { useMutation } from '@apollo/client'
import { Text, useMantineTheme } from '@mantine/core'
import { useModals } from '@mantine/modals'
import { parseInt } from 'lodash'
import useTranslation from 'next-translate/useTranslation'
import { useRouter } from 'next/router'

const useTEItem = ({
  item,
  handleUpdate,
}: {
  item: TrainingExperience
  handleUpdate: ({ newTE }: { newTE: TrainingExperience[] }) => void
}) => {
  const { colorScheme } = useMantineTheme()
  const isDark = colorScheme === 'dark'
  const { t } = useTranslation('common')
  const modals = useModals()
  const { query } = useRouter()

  //open update modal
  const openTrainingExperience = (p: TrainingExperience) =>
    modals.openModal({
      title: t('education'),
      children: <TrainingExperienceForm item={p} handleUpdate={handleUpdate} />,
    })
  //remove training experience mutation
  const [remove, { loading }] = useMutation(RemoveTrainingExperienceDocument, {
    onCompleted(data) {
      handleUpdate({
        newTE: data.removeTrainingExperience as TrainingExperience[],
      })
      modals.closeAll()
    },
  })
  //open confirm remove modal
  const openDeleteMessage = (id: number) =>
    modals.openConfirmModal({
      title: t('education'),
      children: <Text size="sm">{t('deleteTEMessage')}</Text>,
      labels: { confirm: t('confirm'), cancel: t('cancel') },
      async onConfirm() {
        await remove({
          variables: {
            where: {
              userId: parseInt(query.id as string),
              trainingExperienceId: id,
            },
          },
        })
      },
    })

  return {
    openDeleteMessage,
    openTrainingExperience,
    loading,
  }
}
export default useTEItem
